import { IDanhSachLopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/IDanhSachLopTinChiSelectRequest";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IDanhSachLopTinChiViewModel } from "../../../model/respone/lop-tin-chi/IDanhSachLopTinChiViewModel";
import { IDanhSachLopTinChiiActionTypes } from "../../action-types/lop-tin-chi/IDanhSachLopTinChiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDanhSachLopTinChiReducer } from "../../reducer-model/lop-tin-chi/IDanhSachLopTinChiReducer";

const iniState: IDanhSachLopTinChiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  raSoatTongHop: {
    danhsachLopTinChis: {} as IPagingResult<IDanhSachLopTinChiViewModel[]>,
    request: {
      filerMode: "chua-tong-hop",
      page_index: 0,
      page_size: 100,
      id_lops: [] as number[],
    } as IDanhSachLopTinChiSelectRequest,
    status: eReducerStatusBase.is_not_initialization,
  },
};
export const danhSachLopTinChiReducer = (
  state: IDanhSachLopTinChiReducer = iniState,
  action: IDanhSachLopTinChiiActionTypes
): IDanhSachLopTinChiReducer => {
  switch (action.type) {
    case "DANH_SACH_LOP_TIN_CHI_LOAD_CHUA_TONG_HOP_TC_START":
      return {
        ...state,
        raSoatTongHop: {
          ...state.raSoatTongHop,
          status: eReducerStatusBase.is_loading,
        },
      };
    case "DANH_SACH_LOP_TIN_CHI_LOAD_CHUA_TONG_HOP_TC_SUCCESS":
      return {
        ...state,
        raSoatTongHop: {
          ...state.raSoatTongHop,
          danhsachLopTinChis: action.payload,
          status: eReducerStatusBase.is_completed,
        },
      };
    case "DANH_SACH_LOP_TIN_CHI_LOAD_CHUA_TONG_HOP_TC_ERRR":
      return {
        ...state,
        raSoatTongHop: {
          ...state.raSoatTongHop,
          status: eReducerStatusBase.is_completed,
        },
      };
    case "DANH_SACH_LOP_TIN_CHI_CHANGE_REQUEST_CHUA_TONG_HOP_TC":
      return {
        ...state,
        raSoatTongHop: {
          ...state.raSoatTongHop,
          status: eReducerStatusBase.is_need_reload,
          request: {
            ...state.raSoatTongHop.request,
            ...action.payload,
          },
        },
      };
    case "DANH_SACH_LOP_TIN_CHI_EXPORT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_exporting,
      };
    case "DANH_SACH_LOP_TIN_CHI_EXPORT_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_exported,
      };
    case "DANH_SACH_LOP_TIN_CHI_EXPORT_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_exported,
      };
    default:
      return state;
  }
};
